import { apiUrl, DATA_EXPIRE } from '../config';
import { StoreInstance } from '../store';

export const formatUrl = (path) => apiUrl + path;

export function authHeader() {
  const { auth } = StoreInstance.getState();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (auth && auth.token) {
    headers.Authorization = `JWT ${auth.token}`;
  }
  return headers;
}

export const dataLoader = (store, dispatch, request) => {
  if (!store || !store.loaded || Date.now() - store.timestamp > DATA_EXPIRE) {
    request ? dispatch(request) : dispatch();
  }
};

async function get(path) {
  const url = formatUrl(path);
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: authHeader(),
    });

    if (!response.ok) {
      throw Error(response.status);
    }

    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    return null;
  }
}

async function post(path, data) {
  const url = formatUrl(path);
  const response = await fetch(url, {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw Error(response.status);
  }

  const jsonData = await response.json();
  return jsonData;
}

async function put(path, data) {
  const url = formatUrl(path);

  const response = await fetch(url, {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(data),
  });

  const jsonData = await response.json();

  if (!response.ok) {
    throw jsonData;
  }

  return jsonData;
}

const dateFormats = {
  long: {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  longer: {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  numeric: {},
};

export function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatDate(date, langCode = 'en', format = 'long') {
  const unLocalizedDate = new Date(date);
  return new Intl.DateTimeFormat(langCode, dateFormats[format]).format(
    unLocalizedDate,
  );
}

export function formatList(
  list,
  langCode = 'es-MX',
  options = {
    style: 'long',
    type: 'conjunction',
  },
) {
  const formatter = new Intl.ListFormat(langCode, options);
  return formatter.format(list);
}

export function getLookerWeekRange(date) {
  const formatDate = new Date(date);
  const first = formatDate.getDate() - (formatDate.getDay() - 1);
  const nextFirst = first + 7;

  const firstDay = new Date(formatDate.setDate(first));
  const nextFirstDay = new Date(formatDate.setDate(nextFirst));

  return {
    weekStart: formatLookerFilterDate(firstDay),
    nextWeekStart: formatLookerFilterDate(nextFirstDay),
  };
}

export function formatLookerFilterDate(date) {
  const formatDate = new Date(date);
  const month = `${formatDate.getMonth() + 1}`.padStart(2, '0');
  const day = `${formatDate.getDate()}`.padStart(2, '0');
  const year = formatDate.getFullYear();

  return [year, month, day].join('%2F');
}

export const service = {
  get,
  post,
  put,
};
